import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("button", {
    "class": _normalizeClass({
      'ButtonBasic': true,
      'ButtonBasic--disabled': _ctx.isDisabled
    })
  }, [_createTextVNode(_toDisplayString(_ctx.label) + " ", 1), _renderSlot(_ctx.$slots, "default", {}, undefined, true)], 2);
}